import App from "App";
import { Navigate } from "react-router-dom";
import ErrorPage from "./ErrorPage";
import Dashboard from "@features/dashboard";
import { getLoggedInUser } from "@utils/helpers";
import RegulatorFilling from "@features/regulatorFilling";
import ImportExport from "@features/importExport";
import OtherInsights from "@features/otherInsights";
import Preview from "@common/Page/component/Preview";
import ProductInsights from "@features/productInsights";
import Settings from "@features/settings";
import Users from "@features/settings/pages/Users";
import { ADMIN, USER } from "@utils/roleRights";
import AdvanceSearch from "@features/advanceSearch";

const ProtectedRoute = ({ element, allowedRoles }) => {
  const user = getLoggedInUser();
  const isAuthenticated = user && user.loggedIn;

  const role = user && user?.user?.isAdmin ? "ADMIN" : "USER";
  if (allowedRoles && !allowedRoles.includes(role)) {
    return <Navigate to="/" state={{ replace: true }} />;
  }

  return isAuthenticated ? element : <Navigate to="/login" />;
};

const routes = [
  {
    path: "/",
    element: <App />,
    errorElement: <ErrorPage />,
    allowedRoles: [ADMIN, USER],
    children: [
      { index: true, element: <Dashboard />, allowedRoles: [ADMIN, USER] },
      {
        path: "/dashboard",
        element: <Dashboard />,
        allowedRoles: [ADMIN, USER],
      },
      {
        path: "/advance_search",
        element: <AdvanceSearch />,
        allowedRoles: [ADMIN, USER],
      },
      {
        path: "/regulator_filling",
        element: <RegulatorFilling />,
        allowedRoles: [ADMIN, USER],
      },
      {
        path: "/import_export",
        element: <ImportExport />,
        allowedRoles: [ADMIN, USER],
      },
      {
        path: "/other_insights",
        element: <OtherInsights />,
        allowedRoles: [ADMIN, USER],
      },
      { path: "/preview", element: <Preview />, allowedRoles: [ADMIN, USER] },
      {
        path: "/product_insights",
        element: <ProductInsights />,
        allowedRoles: [ADMIN, USER],
      },
      { path: "/settings", element: <Settings />, allowedRoles: [ADMIN] },
      {
        path: "/settings/manage-users",
        element: <Users />,
        allowedRoles: [ADMIN],
      },
    ],
  },
];

export const protectedRoutes = [
  ...routes.map((route) => {
    return {
      path: route.path,
      element: (
        <ProtectedRoute
          element={route.element}
          allowedRoles={route.allowedRoles}
        />
      ),
      errorElement: route.errorElement,
      children:
        route.children && route.children?.length
          ? route.children.map((route) => {
              return {
                path: route.path,
                element: (
                  <ProtectedRoute
                    element={route.element}
                    allowedRoles={route.allowedRoles}
                  />
                ),
                index: route.index,
              };
            })
          : [],
    };
  }),
];
